import BottomSheet from '../BottomSheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faScroll, faLightbulb } from '@fortawesome/free-solid-svg-icons';

export default function ParashaDetailModal({ isOpen, onClose, parasha }) {
  if (!parasha) return null;

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="This Week's Torah Reading"
    >
      <div className="p-6 space-y-8">
        {/* Explanation Banner */}
        <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-2xl p-5 border border-primary/20">
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faBook} className="text-3xl text-primary mt-1" />
            <div>
              <h3 className="font-bold text-text-primary mb-2">
                The Weekly Torah Cycle
              </h3>
              <p className="text-sm text-text-secondary leading-relaxed">
                Each week, Jewish communities around the world read a portion (parasha) from the Torah alongside a related reading (haftarah) from the Prophets or Writings. Over the course of a year, we complete the entire Torah and begin again, creating an endless cycle of learning and reflection.
              </p>
            </div>
          </div>
        </div>

        {/* Torah Portion */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <FontAwesomeIcon icon={faScroll} className="text-3xl text-primary" />
            <div>
              <h3 className="text-sm font-bold text-text-secondary uppercase tracking-wide">
                Torah Portion
              </h3>
            </div>
          </div>
          
          <div className="bg-white rounded-xl border border-border p-5">
            <div className="flex items-baseline justify-between mb-3">
              <h2 className="text-2xl font-serif font-bold text-primary" dir="rtl">
                {parasha.hebrewName}
              </h2>
              <span className="text-lg font-serif text-text-secondary">
                {parasha.englishName}
              </span>
            </div>

            <div className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-semibold italic mb-4">
              {parasha.mainIdea}
            </div>

            <div className="prose prose-sm max-w-none">
              <p className="text-text-primary leading-relaxed whitespace-pre-line">
                {parasha.story}
              </p>
            </div>
          </div>
        </div>

        {/* Haftarah */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <FontAwesomeIcon icon={faBook} className="text-3xl text-accent" />
            <div>
              <h3 className="text-sm font-bold text-text-secondary uppercase tracking-wide">
                Haftarah
              </h3>
            </div>
          </div>
          
          <div className="bg-white rounded-xl border border-border p-5">
            <div className="flex items-baseline justify-between mb-3">
              <h2 className="text-xl font-serif font-bold text-accent" dir="rtl">
                {parasha.haftarah.hebrewName}
              </h2>
              <span className="text-sm text-text-secondary font-semibold">
                {parasha.haftarah.source}
              </span>
            </div>

            <div className="inline-block bg-accent/10 text-accent-dark px-3 py-1 rounded-full text-sm font-semibold italic mb-4">
              {parasha.haftarah.mainIdea}
            </div>

            <div className="prose prose-sm max-w-none">
              <p className="text-text-primary leading-relaxed whitespace-pre-line">
                {parasha.haftarah.story}
              </p>
            </div>
          </div>
        </div>

        {/* Connection */}
        <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-xl p-5 border border-border">
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faLightbulb} className="text-2xl text-primary mt-1" />
            <div>
              <h4 className="font-bold text-text-primary mb-2">
                Why These Together?
              </h4>
              <p className="text-sm text-text-secondary leading-relaxed">
                The haftarah reading is chosen to thematically connect with the Torah portion, often echoing its themes, mirroring its events, or providing prophetic commentary on its lessons.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="pt-4 border-t border-border">
          <button
            onClick={onClose}
            className="w-full bg-primary text-white font-bold py-3 rounded-xl hover:bg-primary-dark transition-colors touch-target"
          >
            Close
          </button>
        </div>
      </div>
    </BottomSheet>
  );
}

